export const messageServicesKey = "/engagement/:app_group_id/sms_messaging_services" as const;
